var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInputErrorIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4495"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99957 11.1105C7.94063 11.1105 7.88411 11.087 7.84243 11.0454C7.80076 11.0037 7.77734 10.9472 7.77734 10.8882C7.77734 10.8293 7.80076 10.7728 7.84243 10.7311C7.88411 10.6894 7.94063 10.666 7.99957 10.666",
    stroke: "#C12010",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8 11.1105C8.05894 11.1105 8.11546 11.087 8.15714 11.0454C8.19881 11.0037 8.22222 10.9472 8.22222 10.8882C8.22222 10.8293 8.19881 10.7728 8.15714 10.7311C8.11546 10.6894 8.05894 10.666 8 10.666",
    stroke: "#C12010",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8 8.88889V4",
    stroke: "#C12010",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.99967 14.6663C11.6815 14.6663 14.6663 11.6815 14.6663 7.99967C14.6663 4.3179 11.6815 1.33301 7.99967 1.33301C4.3179 1.33301 1.33301 4.3179 1.33301 7.99967C1.33301 11.6815 4.3179 14.6663 7.99967 14.6663Z",
    stroke: "#C12010",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputErrorIcon);
export default __webpack_public_path__ + "static/media/input-error-icon.c807c6fbcb93c65080d2e5f7c72b0bf3.svg";
export { ForwardRef as ReactComponent };